import { render, staticRenderFns } from "./device-form.vue?vue&type=template&id=118d8290"
import script from "./device-form.vue?vue&type=script&lang=js"
export * from "./device-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports